import { Property, AppUser, UserRole } from '../types';

export interface LeadData {
  nombre: string;
  movil: string;
  correo: string;
  tipoId: string;
  numeroId: string;
}

const BROKER_LEAD_WEBHOOK_URL = 'https://segurobolivar-trial.app.n8n.cloud/webhook-test/8f0f8830-63d2-45f9-b4e7-0bd96e71837e';
const CLIENT_LEAD_WEBHOOK_URL = 'https://segurobolivar-trial.app.n8n.cloud/webhook/8f0f8830-63d2-45f9-b4e7-0bd96e71837e';

export const POTENTIAL_OWNERS = [
  "Afydi", "Aliado Inmobiliaria", "Banco Agrario", "Banco de Bogotá", "Banco de occidente", "BBVA", 
  "Claro", "Colpatria", "Constructora Bolívar", "Constructora Capital", "Davivienda", "Habi", 
  "Inmobiliaria Bogotá", "ITAU", "Negociación especial", "Pads", "Pichincha", "Propio", "Seguros Bolivar", 
  "Caridix Inmobiliaria", "Nitro Inmobiliaira", "LOGISTICA Y CONSULTORIA Y SERVICIOS INMOBILIARIOS LCS LTDA", 
  "red real state digital", "Casa 360", "Monserrate - Medellin", "Valor Tierra Inmobiliaria", "Tu casa.com", 
  "Inmobiliaria Integrity", "Bienes Inmobiliarios de colombia SAS.", "ADMINISTRADORA NUEVA CIUDAD LTDA", 
  "Inmobiliaria Aliadas venta", "Gestiones Inmobiliarias FT S.A.S.", "MLS Medellín"
];

const idTypeMapping: Record<string, string> = {
  CC: 'Cédula de ciudadanía', CE: 'Cédula de extranjería', ITIN: 'ITIN number', LC: 'Licencia de conducción',
  NIT: 'Nit', PAS: 'Pasaporte', PEP: 'Permiso especial de permanencia', RC: 'Registro Civil',
  SSN: 'Social Security Number (SSN)', TI: 'Tarjeta de identidad', TE: 'Tarjeta extranjería', TDE: 'Tipo de documento extranjero',
};

const normalize = (str: string) => str.toLowerCase().trim();

const determineOwner = (strategy: string | null | undefined, defaultOwner: string): string => {
  if (!strategy) return defaultOwner;
  const norm = normalize(strategy);
  if (norm === 'ciencuadras - habi' || norm === 'ciencuadras-habi') {
    return POTENTIAL_OWNERS.find(o => normalize(o) === 'habi') || 'Ciencuadras - Habi';
  }
  for (const owner of POTENTIAL_OWNERS) {
    if (norm.includes(normalize(owner))) return owner;
  }
  return defaultOwner;
};

export const submitLead = async (property: Property, leadData: LeadData, appUser: AppUser | null): Promise<{ success: boolean; message: string }> => {
  try {
    const isClient = appUser?.role === UserRole.CLIENTE;
    const webhookUrl = isClient ? CLIENT_LEAD_WEBHOOK_URL : BROKER_LEAD_WEBHOOK_URL;
    const owner = determineOwner(property.estrategiaComercial, property.owner);
    const fullTipoId = idTypeMapping[leadData.tipoId] || leadData.tipoId;
    
    const publicUrl = property.path ? (property.path.toLowerCase().startsWith('http') ? property.path : `https://www.ciencuadras.com${property.path.startsWith('/') ? property.path : `/${property.path}`}`) : `https://www.ciencuadras.com/inmueble/codigo-${property.codigo}`;

    const payload = {
      codigo: property.codigo, owner, nombre_cliente: leadData.nombre, telefono: leadData.movil,
      email_cliente: leadData.correo, tipoId: fullTipoId, numeroId: leadData.numeroId,
      fuente: 'App Inventario Comercial', compania: 'Ciencuadras', soloInteresado: 1,
      propertyOfInterestValueForm: property.precio_venta, propertyCodeForm: property.codigo, Valor_Arriendo: 0,
      propertyTypeForm: property.tipoinmueble, cityForm: property.ciudad, localityForm: property.localidad,
      neighborhoodForm: property.neighborhoodName, urlProperty: publicUrl, lineOfBusinessForm: 'Remates',
      lineaDeNegocio: 'Remates', accountForm: 'Ciencuadras',
    };
    
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error(`Error del servidor (${response.status}): ${errorBody || response.statusText}`);
    }

    return { success: true, message: "Lead creado exitosamente." };
  } catch (error: any) {
    console.error("Error submitting lead to n8n webhook:", error);
    return {
      success: false,
      message: error?.message?.toLowerCase().includes('failed to fetch') ? 'Error de red. No se pudo conectar con el servidor.' : (error?.message || 'Error inesperado al enviar los datos.')
    };
  }
};
